/* eslint-disable */

import React, { useEffect, useState } from "react";
import SideBar from "../components/views/SideBar";
import styled from "styled-components";
import axios from "axios";
import { RxCross2 } from "react-icons/rx";
import { MdDiscount } from "react-icons/md";
import Swal from "sweetalert2";
import { useNavigate, useLocation, Link, useParams } from "react-router-dom";
import apiInstance from "../utils/api";
import { Typeahead } from 'react-bootstrap-typeahead'
const Top = styled.div`
  display: flex;
  justify-content: center;
  margin: 10px 0;
`;

const Button = styled.button`
  background: #007bff;
  color: white;
  justify-content: center;
  padding: 5px 30px;
  border: none;
  border-radius: 10px;
`;
const Div = styled.div``;
const Textarea = styled.textarea`
  margin-top: 20px;
  width: 100%;
`;
const Table = styled.table``;
const Thead = styled.thead``;
const Tbody = styled.tbody``;
const Tr = styled.tr`
  text-align: center;
`;
const Th = styled.th`
  font-size: 15px;
`;
const Td = styled.td`
  font-size: 14px;
`;
const Select = styled.select`
  width: 100%;
  padding: 6px 5px;
  border-radius: 7px;
`;
const Input = styled.input`
  width: 100%;
  margin-top: 20px;
`;
const Label = styled.label``;

const Option = styled.option``;

const TestVoucherEdit = () => {
    const [pname, setPname] = useState("");
    const [pcode, setPcode] = useState("");
    const [code, setCode] = useState("");
    const [date, setDate] = useState("");
    const [email, setEmail] = useState("");
    const [total, setTotal] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [net, setNet] = useState(0);
    const [pay, setPay] = useState(0);
    const [change, setChange] = useState(0);
    const [option, setOption] = useState("Collect");
    const [branch, setBranch] = useState("AL");
    const [servs, setServs] = useState([]);
    const [doctors, setDoctors] = useState([]);
    const [referClinic, setReferClinic] = useState("");
    const [arr, setArr] = useState([]);
    const [array, setArray] = useState([]);
    const [labId, setLabId] = useState("");
    const [voucherCode, setVoucherCode] = useState("");
    const [isDoctor, setIsDoctor] = useState(false);
    const [isEmail, setIsEmail] = useState(false);
    const [bankShow, setBankShow] = useState(false);
    const [cashShow, setCashShow] = useState(false);
    const [bankList, setBankList] = useState([]);
    const [cashList, setCashList] = useState([]);
    const [accountingList, setAccountingList] = useState([]);
    const [relatedBankAcc, setRelatedBankAcc] = useState("");
    const [relatedCashAcc, setRelatedCashAcc] = useState("");
    const [seq, setSeq] = useState("");
    const [voucherObjectID, setVoucherObjectID] = useState('');
    const [showPrint, setShowPrint] = useState(false);
    const [patient_id, setPatientID] = useState("")
    const { id } = useParams()
    // const patient_id = useLocation().pathname.split("/")[2];
    const navigate = useNavigate();

    const [doctorSelection, setDoctorSelection] = useState([])
    const [testSelection, setTestSelection] = useState([])
    const [defaultDoctorId, setDefaultDoctorId] = useState("")
    useEffect(() => {
        const defaultDoctor = doctors.find(doc => doc._id === defaultDoctorId);
        if (defaultDoctor) {
            setDoctorSelection([defaultDoctor]);
        }
    }, [doctors]);
    useEffect(() => {
        const getCashLists = async () => {
            try {
                const res = await apiInstance.get(
                    "accounting-lists"
                    // "http://localhost:9000/api/accounting-lists"
                );

                const cash = res.data.list.filter(
                    (el) =>
                        el.relatedSubHeader.name == "Cash" &&
                        el.relatedHeader.name == "Current Asset" &&
                        el.relatedType.name === "Assets"
                );
                setCashList(cash);
            } catch (err) { }
        };

        const getBankLists = async () => {
            try {
                const res = await apiInstance.get(
                    "accounting-lists"
                    // "http://localhost:9000/api/accounting-lists"
                );

                const bank = res.data.list.filter(
                    (el) =>
                        el.relatedSubHeader.name == "Bank" &&
                        el.relatedHeader.name == "Current Asset" &&
                        el.relatedType.name === "Assets"
                );
                setBankList(bank);
            } catch (err) { }
        };

        const getAccountingLists = async () => {
            try {
                const res = await apiInstance.get(
                    "accounting-lists"
                );
                const acc = res.data.list.filter(
                    (e) => e.relatedType.name == "Revenues"
                );

                setAccountingList(acc);
            } catch (err) { }
        };

        const getVoucherCode = async () => {
            try {
                const res = await apiInstance.get(
                    "vouchers/code/" +
                    patient_id
                );

                // console.log(res.data.data);
                setVoucherCode(res.data.data.voucherID);
                setSeq(res.data.data.seq);
            } catch (err) { }
        };

        const getPatient = async () => {
            try {
                const res = await apiInstance.get(
                    "patient/" +
                    patient_id
                );
                setPname(res.data.data.name);
                setPcode(res.data.data.patientID);
            } catch (err) { }
        };
        const getServs = async () => {
            try {
                const res = await apiInstance.get(
                    "services"
                );
                // console.log("good");
                setServs(res.data.data);
            } catch (err) { }
        };
        const getDoctors = async () => {
            try {
                const res = await apiInstance.get(
                    "doctors"
                );
                setDoctors(res.data.data);
            } catch (err) { }
        };
        const getVoucherDetail = async () => {
            try {
                const res = await apiInstance.get(
                    `voucher/${id}`
                );
                // console.log(res.data.data, 'vou detail')
                const vouData = res.data.data
                let arrListDataPrepare = vouData?.testSelection && vouData?.testSelection.map((i) => {
                    return i.name
                })
                setDate(vouData?.date)
                setLabId(vouData?.labId)
                setVoucherCode(vouData?.code)
                setPname(vouData?.relatedPatient?.name)
                setPcode(vouData?.relatedPatient?.patientID)
                setIsDoctor(vouData?.referDoctor ? true : false)
                setDefaultDoctorId(vouData?.referDoctor?._id)
                setOption(vouData?.options)
                setEmail(email)
                setIsEmail(vouData?.options === "Email" ? true : false)
                setBankShow(vouData?.relatedBank[0] && true)
                setCashShow(vouData?.relatedCash[0] && true)
                setRelatedCashAcc(vouData?.relatedCash[0])
                setRelatedBankAcc(vouData?.relatedBank[0])
                setBranch(vouData?.branch)
                setReferClinic(vouData?.referClinic)
                setArr(arrListDataPrepare)
                setPatientID(vouData?.relatedPatient?._id)
                setTotal(vouData?.totalCharge)
                // setDoctors(res.data.data);

            } catch (err) { }
        };
        getVoucherDetail()
        getPatient();
        getServs();
        getDoctors();
        getCashLists();
        getVoucherCode();
        getBankLists();
        getAccountingLists();
    }, []);

    const addService = async (id) => {
        // console.log(arr, 'arr')
        const isAlready = arr.filter((el) => el._id === id)[0];
        // console.log(isAlready, 'isAl')
        if (arr[0] && isAlready) {
            Swal.fire({
                title: "Please choose again!",
                text: "Already Added!",
                icon: "error",
                showConfirmButton: false,

                timer: 3000
            });
        } else {
            const res = await apiInstance.get(
                "service/" +
                //"http://localhost:9000/api/service/" +
                id
            );
            // console.log(res.data.data, "res.data.data");
            setArr((arr) => [...arr, res.data.data]);
            setTotal(total + res.data.data.charges);
            setNet(total + res.data.data.charges);
            const obj = {
                name: res.data.data._id,
                qty: 1,
                unitCharge: res.data.data.charges,
                subCharge: res.data.data.charges,
                subTestFlag: res.data.data.subTestFlag,
                subTest: res.data.data.subTest
            };
            // console.log(obj, 'obj')
            setArray((array) => [...array, obj]);
            setTestSelection([])
        }
    };
    // console.log(arr, 'arr')

    const delSer = (id) => {

        const updatedArr = arr.filter((el) => el._id !== id);
        // console.log(updatedArr, 'arr')
        const updatedArray = array.filter((el) => el._id !== id);
        // console.log(updatedArray, 'arr')
        const newTotal = updatedArr.reduce((acc, cur) => acc + Number(cur.charges || 0), 0);

        setArr(updatedArr);
        setArray(updatedArr);
        setTotal(newTotal);
        setNet(newTotal);
    };



    const testSaveTest = () => {
        Swal.fire({
            title: "Success",
            text: "successfully Registered!",
            icon: "success",
            confirmButtonText: 'OK',
        }).then(result => {

        });
    }

    const saveTest = () => {
        const finalArray = arr.map((test) => {
            return {
                name: test._id,
                qty: 1,
                unitCharge: test.charges,
                subCharge: test.charges,
                subTestFlag: test.subTestFlag,
                subTest: test.subTest
            }
        })
        // console.log(finalArray, 'finalArray')
        const data = {
            id: id,
            labId: labId,
            code: voucherCode,
            relatedAccounting: '64659ac6c69c2b2f847c3b20',
            date: date,
            relatedPatient: patient_id,
            referClinic: referClinic,
            options: option,
            branch: branch,
            email: email,
            testSelection: finalArray,
            totalCharge: total,
            discount: discount,
            netDiscount: total - discount,
            pay: pay,
            change: pay < (total - discount) ? change : 0,
            repayAmount: (total - discount) === pay ? 0 : (total - discount) > pay ? (total - discount) - pay : 0,
            seq: seq,
        };
        if (relatedCashAcc) data.relatedCash = relatedCashAcc;
        if (relatedBankAcc) data.relatedBank = relatedBankAcc;
        if (doctorSelection[0]) data.referDoctor = doctorSelection[0]._id;

        if (change < 0) {
            data.creditAmount = change;
        }
        try {

            apiInstance
                .put("voucher", data)
                //  .post("http://localhost:9000/api/voucher", data)
                .then(function (response) {
                    // console.log(response.data.data._id, 'here')
                    setVoucherObjectID(response.data.data._id)
                    setShowPrint(true);
                    //console.log(res.data.data);
                    Swal.fire({
                        title: "Success",
                        text: "successfully Updated!",
                        icon: "success",
                        showConfirmButton: false,
                        timer: 2000
                    });
                    navigate
                    setPay(0)
                    setDiscount(0)
                    setTotal(0)
                    setChange(0)
                    setArr([])
                    setArray([])
                }
                )
        } catch (e) {
            Swal.fire({
                title: "Error",
                text: "Something Wrong",
                icon: "error",
                confirmButtonText: "CANCEL",
            });

        };
    }
    const print = () => {
        var print_div = document.getElementById("print");
        var print_area = window.open();
        print_area.document.write(print_div.innerHTML);
        print_area.document.close();
        print_area.focus();
        print_area.print();
        print_area.close();
        // saveTest();
    };
    return (
        <div className="wrapper">
            <SideBar />
            {/* <!-- Content Wrapper. Contains page content --> */}

            <div className="content-wrapper" id="ifmcontentstoprint">
                {/* <!-- Content Header (Page header) --> */}
                <div className="content-header">
                    <div className="container-fluid">

                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to={`/test_voucher/${patient_id}`}>Back</Link>
                                    </li>
                                    <li className="breadcrumb-item active">Edit Voucher</li>
                                </ol>
                            </div>

                        </div>
                        <Top>
                            {/* <Right><Button>Refresh</Button></Right> */}
                            <h5 className="text-center text-xl font-weight-bold">Lab Test Voucher Edit</h5>
                        </Top>
                        <Div className="card">
                            <Div className="card-body row">
                                <Div className="row">
                                    <div className="col-4">
                                        <label htmlFor="">Voucher Date</label>
                                        <input
                                            type="date"
                                            value={date?.split("T")[0]}
                                            className="form-control"
                                            onChange={(e) => setDate(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-4">
                                        <label htmlFor="">Lab ID</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={labId}
                                            placeholder="Enter Lab Id"
                                            onChange={(e) => setLabId(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-4">
                                        <label htmlFor="">Voucher Code</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            defaultValue={voucherCode}
                                        />
                                    </div>
                                    <div className="col-6 mt-2">
                                        <label htmlFor="">Patient Name</label>
                                        <input type="text" className="form-control" value={pname} />
                                    </div>
                                    <div className="col-6 mt-2">
                                        <label htmlFor="">Patient Code</label>
                                        <input type="text" className="form-control" value={pcode} />
                                    </div>
                                    <div className="col-6 mt-4">
                                        <label htmlFor="">Refer Doctor</label>
                                        <input
                                            className="ml-4"
                                            type="radio"
                                            name="doctordata"
                                            checked={isDoctor === true && true}
                                            id="male"
                                            onClick={() => setIsDoctor(true)}
                                        />{" "}
                                        Yes
                                        <input
                                            className="ml-4"
                                            type="radio"
                                            name="doctordata"
                                            id="male"
                                            checked={isDoctor === false && true}
                                            onClick={() => setIsDoctor(false)}
                                            active
                                        />{" "}
                                        No
                                    </div>
                                    {isDoctor && (
                                        <div className="col-6 mt-2">
                                            <label htmlFor="">Select Doctor</label>



                                            <Typeahead
                                                id='basic-typeahead-single'
                                                labelKey='name'
                                                onChange={setDoctorSelection}
                                                options={doctors}
                                                placeholder='Choose doctor...'
                                                selected={doctorSelection}
                                            />

                                            {/* <select
                        className="form-control"
                        onChange={(e) => setDid(e.target.value)}>
                        <option hidden>Choose Doctor</option>
                        {doctors.map((doc, index) => (
                          <option value={doc._id}>{doc.name}</option>
                        ))}
                      </select> */}
                                        </div>
                                    )}
                                    <div className="col-6 mt-4">
                                        <label htmlFor="">Collect Or Email</label>
                                        <input
                                            className="ml-4"
                                            type="radio"
                                            name="data"
                                            id="col"
                                            checked={option === 'Collect' && true}
                                            onClick={() => {
                                                setIsEmail(false);
                                                setOption("Collect");
                                            }}
                                            active
                                        />{" "}
                                        Collect
                                        <input
                                            className="ml-4"
                                            type="radio"
                                            name="data"
                                            id="col"
                                            checked={option === 'Email' && true}
                                            onClick={() => {
                                                setIsEmail(true);
                                                setOption("Email");
                                            }}
                                        />{" "}
                                        Email
                                    </div>
                                    {isEmail && (
                                        <div className="col-6 mt-2">
                                            <label htmlFor="">Email</label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                        </div>
                                    )}

                                    <div className="row">
                                        <div className="col-md-6 mt-4">
                                            <label htmlFor="">Bank / Cash</label>
                                            <input
                                                className="ml-4"
                                                type="radio"
                                                name="acc"
                                                id="male"
                                                checked={bankShow && true}
                                                onClick={() => {
                                                    setBankShow(true);
                                                    setCashShow(false);
                                                }}
                                            />{" "}
                                            Bank
                                            <input
                                                className="ml-4"
                                                type="radio"
                                                name="acc"
                                                id="male"
                                                checked={cashShow && true}
                                                onClick={() => {
                                                    setBankShow(false);
                                                    setCashShow(true);
                                                }}
                                                active
                                            />{" "}
                                            Cash
                                        </div>

                                        {bankShow && (
                                            <div className="col-6 mt-3">
                                                <label className="ml-2">Select Bank</label>
                                                <select
                                                    className="form-control"
                                                    onChange={(e) => setRelatedBankAcc(e.target.value)}>
                                                    <option>{bankList.find((el) => el._id === relatedBankAcc) ? bankList.find((el) => el._id === relatedBankAcc).name : "Choose Cash"}</option>
                                                    {bankList.map((doc, index) => (
                                                        <option value={doc._id}>{doc.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        )}

                                        {cashShow && (
                                            <div className="col-6 mt-3">
                                                <label className="ml-2">Select Cash</label>
                                                <select
                                                    className="form-control"
                                                    onChange={(e) => setRelatedCashAcc(e.target.value)}>
                                                    <option>{cashList.find((el) => el._id === relatedCashAcc) ? cashList.find((el) => el._id === relatedCashAcc).name : "Choose Cash"}</option>
                                                    {cashList.map((doc, index) => (
                                                        <option value={doc._id}>{doc.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        )}
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mt-4">
                                            <label>Branch</label>
                                            <select
                                                name="branch"
                                                id="branch"
                                                className="form-control"
                                                //  onchange="convert(this.value)"
                                                onChange={(event) =>
                                                    setBranch(event.target.value)

                                                }>
                                                <option hidden>{branch ? branch : "Choose Branch"}</option>

                                                <option value="Hlaing">
                                                    Hlaing
                                                </option>



                                            </select>
                                        </div>
                                        <div className="col-md-6 mt-4">
                                            <label>Refer Clinic</label>
                                            <input
                                                type="text"
                                                value={referClinic}
                                                className="form-control"
                                                onChange={(e) => setReferClinic(e.target.value)}
                                            />
                                        </div>

                                    </div>
                                    {/* <div className="row">
                    <div className="col-md-6"></div>
                    <div className="col-6 mt-3">
                      <label className="ml-2">Income Account</label>
                      <select
                        className="form-control"
                        onChange={(e) => setAccount(e.target.value)}>
                        <option>Lab Test Sales</option>
                        {accountingList.map((doc, index) => (
                          <option value={doc._id}>{doc.name}</option>
                        ))}
                      </select>
                    </div>
                  </div> */}

                                    <Div className="col-10 mt-5">
                                        <label>Select Service</label>
                                        <Typeahead
                                            id='basic-typeahead-single'
                                            labelKey='name'
                                            onChange={setTestSelection}
                                            options={servs}
                                            placeholder='Choose service...'
                                            selected={testSelection}
                                        />
                                        {/* <Select
                      onChange={(e) => setSerId(e.target.value)}
                      id="changes">
                      <Option hidden>Select Service</Option>
                      {servs.map((ser, index) => (
                        <Option value={ser._id}>{ser.name}</Option>
                      ))}
                    </Select> */}
                                    </Div>
                                    <Div className="col-2" style={{ marginTop: '5rem' }}>
                                        <Button className={!testSelection[0] ? 'opacity-50' : ''} disabled={!testSelection[0]} onClick={() => addService(testSelection[0]._id)}>Add</Button>
                                    </Div>
                                </Div>
                                <Table className="table table-hover mt-4">
                                    <Thead>
                                        <Tr>
                                            <Th>No.</Th>
                                            <Th>Name</Th>
                                            <Th>Qty</Th>
                                            <Th>Unit Charge</Th>
                                            <Th>Sub Charge</Th>
                                            <Th></Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        {arr.map((ar, i) => (
                                            <Tr key={ar._id}>
                                                <Td>{++i}</Td>
                                                <Td>{ar.name}</Td>
                                                <Td>1</Td>
                                                <Td>{ar.charges}</Td>
                                                <Td>{ar.charges}</Td>
                                                <Td>
                                                    <RxCross2 onClick={() => delSer(ar._id, i)} />
                                                </Td>
                                            </Tr>
                                        ))}
                                    </Tbody>
                                    <tfoot>
                                        <Tr>
                                            <Td colSpan="5" className="text-right">
                                                Total Charge
                                            </Td>
                                            <Td>{total}</Td>
                                        </Tr>
                                        <Tr>
                                            <Td colSpan="5" className="text-right">
                                                Discount
                                            </Td>
                                            <Td>  <input
                                                type="number"
                                                onWheel={(e) => e.target.blur()}
                                                value={discount}
                                                onWheel={(e) => e.target.blur()}
                                                onChange={(e) => {
                                                    setDiscount(e.target.value)
                                                }}
                                            /></Td>
                                        </Tr>
                                        <Tr>
                                            <Td colSpan="5" className="text-right">
                                                Net Charge
                                            </Td>
                                            <Td>{total - discount}</Td>
                                        </Tr>
                                        <Tr>
                                            <Td colSpan="5" className="text-right">
                                                Pay
                                            </Td>
                                            <Td>
                                                <input
                                                    type="number"
                                                    onWheel={(e) => e.target.blur()}
                                                    value={pay}
                                                    onWheel={(e) => e.target.blur()}
                                                    onChange={(e) => {
                                                        setPay(e.target.value);
                                                        setChange(e.target.value - (total - discount));
                                                    }}
                                                />
                                            </Td>
                                        </Tr>

                                        <Tr>
                                            <Td colSpan="5" className="text-right">
                                                Credit
                                            </Td>
                                            <Td>{pay < (total - discount) ? change : 0}</Td>
                                        </Tr>
                                        <Tr>
                                            <Td colSpan="5" className="text-right">
                                                Change
                                            </Td>
                                            <Td>{pay > (total - discount) ? pay - (total - discount) : 0}</Td>
                                        </Tr>
                                    </tfoot>
                                </Table>
                                <div id="print" width="100%" hidden>
                                    <h3 style={{ textAlign: "center" }}>Lab Test Voucher</h3>
                                    <div className="row">
                                        <div className="col-8">
                                            <span>Voucher Date : {date}</span>
                                        </div>
                                        <div className="offset-1 col-3">
                                            <span>Voucher Code : {code}</span>
                                        </div>
                                    </div>
                                    <Table className="table table-hover mt-4">
                                        <Thead>
                                            <Tr>
                                                <Th>No.</Th>
                                                <Th>Name</Th>
                                                <Th>&nbsp;&nbsp;Qty</Th>
                                                <Th>&nbsp;&nbsp;Unit Charge</Th>
                                                <Th>&nbsp;&nbsp;Sub Charge</Th>
                                                <Th></Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            {arr.map((ar, i) => (
                                                <Tr key={ar._id}>
                                                    <Td>{++i}</Td>
                                                    <Td>{ar.name}</Td>
                                                    <Td>&nbsp;&nbsp;1</Td>
                                                    <Td>&nbsp;&nbsp;{ar.charges}</Td>
                                                    <Td>&nbsp;&nbsp;{ar.charges}</Td>
                                                </Tr>
                                            ))}
                                        </Tbody>
                                        <tfoot>
                                            <br></br>
                                            <Tr>
                                                <Td colSpan="5" style={{ textAlign: "right" }}>
                                                    Total Charge-
                                                </Td>
                                                <Td>{total}</Td>
                                            </Tr>
                                            <Tr>
                                                <Td
                                                    colSpan="5"
                                                    className="text-right"
                                                    style={{ textAlign: "right" }}>
                                                    Discount-
                                                </Td>
                                                <Td style={{ textAlign: "right" }}>0</Td>
                                            </Tr>
                                            <Tr>
                                                <Td
                                                    colSpan="5"
                                                    className="text-right"
                                                    style={{ textAlign: "right" }}>
                                                    Net Charge-
                                                </Td>
                                                <Td style={{ textAlign: "right" }}>{total}</Td>
                                            </Tr>
                                            <Tr>
                                                <Td
                                                    colSpan="5"
                                                    className="text-right"
                                                    style={{ textAlign: "right" }}>
                                                    Pay-
                                                </Td>
                                                <Td style={{ textAlign: "right" }}>{pay}</Td>
                                            </Tr>
                                            <Tr>
                                                <Td
                                                    colSpan="5"
                                                    className="text-right"
                                                    style={{ textAlign: "right" }}>
                                                    Change-
                                                </Td>
                                                <Td style={{ textAlign: "right" }}>{change}</Td>
                                            </Tr>
                                        </tfoot>
                                    </Table>
                                </div>
                                <div className="row mt-5">
                                    <div className="offset-5 col-4">
                                        <button
                                            className="btn btn-sm btn-success"
                                            onClick={saveTest}>
                                            Save
                                        </button>
                                        &nbsp;&nbsp;&nbsp;
                                        {showPrint ? (
                                            <Link to={`/testslip/` + voucherObjectID}>
                                                <button className="btn btn-sm btn-primary">
                                                    Print
                                                </button>
                                            </Link>
                                        ) : <></>}

                                    </div>
                                </div>
                            </Div>
                        </Div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TestVoucherEdit;
